import React from 'react'
import { LuChartColumn, LuCompass, LuHeart, LuMic, LuShield, LuTable2 } from 'react-icons/lu'
import notePad from "../../../images/padu/notepad.webp"

export default function Certified() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full overflow-hidden text-center'>
            <img src={notePad} alt='notePad' loading='lazy' className=' size-[130px] md:size-[190px] object-cover mx-auto' />
            <h3 className='text-[#101828] text-[24px] md:text-[54px] font-semibold mt-[12px]'>Surge Certified Campus</h3>
            <p className='mt-[5px] md:mt-[10px] text-[#7D7F81] font-normal text-[14px] md:text-[25px]'>Each Surge Sunday features a different founder or operator who has:</p>
            <div className='mt-[20px] md:mt-[48px] flex gap-[15px] md:gap-[20px] flex-wrap justify-center items-center md:w-11/12 mx-auto text-[#1E2939] text-[14px] md:text-[23px] font-semibold'>
                <div className='px-[12px] md:px-[32px] py-[10px] md:py-[20px] bg-[#FFF] border border-[#E5E7EB] rounded-[14px] md:rounded-[22px] flex gap-[10px] md:gap-[17px] items-center' style={{ boxShadow: "8px 8px 0px 0px #155DFC1C" }}>
                    <LuShield className='text-[#155DFC]' />
                    <p>Surge Certified Shield</p>
                </div>
                <div className='px-[12px] md:px-[32px] py-[10px] md:py-[20px] bg-[#FFF] border border-[#E5E7EB] rounded-[14px] md:rounded-[22px] flex gap-[10px] md:gap-[17px] items-center' style={{ boxShadow: "8px 8px 0px 0px #9810FA1A" }}>
                    <LuMic className='text-[#9810FA]' />
                    <p>Annual SK keynote</p>
                </div>
                <div className='px-[12px] md:px-[32px] py-[10px] md:py-[20px] bg-[#FFF] border border-[#E5E7EB] rounded-[14px] md:rounded-[22px] flex gap-[10px] md:gap-[17px] items-center' style={{ boxShadow: "8px 8px 0px 0px #E600761A" }}>
                    <LuChartColumn className='text-[#E60076]' />
                    <p>Student clarity & capability reports</p>
                </div>
                <div className='px-[12px] md:px-[32px] py-[10px] md:py-[20px] bg-[#FFF] border border-[#E5E7EB] rounded-[14px] md:rounded-[22px] flex gap-[10px] md:gap-[17px] items-center' style={{ boxShadow: "8px 8px 0px 0px #00A63E1C" }}>
                    <LuCompass className='text-[#00A63E]' />
                    <p>Faculty alignment guidance</p>
                </div>
                <div className='px-[12px] md:px-[32px] py-[10px] md:py-[20px] bg-[#FFF] border border-[#E5E7EB] rounded-[14px] md:rounded-[22px] flex gap-[10px] md:gap-[17px] items-center' style={{ boxShadow: "8px 8px 0px 0px #E600761C" }}>
                    <LuHeart className='text-[#E60076]' />
                    <p>Parent-trust uplift</p>
                </div>
                <div className='px-[12px] md:px-[32px] py-[10px] md:py-[20px] bg-[#FFF] border border-[#E5E7EB] rounded-[14px] md:rounded-[22px] flex gap-[10px] md:gap-[17px] items-center' style={{ boxShadow: "8px 8px 0px 0px #4F39F61C" }}>
                    <LuTable2 className='text-[#4F39F6]' />
                    <p>Campus branding assets</p>
                </div>
            </div>
        </div>
    )
}
